import { render, staticRenderFns } from "./Patient.vue?vue&type=template&id=034054da&"
import script from "./Patient.vue?vue&type=script&lang=ts&"
export * from "./Patient.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('034054da')) {
      api.createRecord('034054da', component.options)
    } else {
      api.reload('034054da', component.options)
    }
    module.hot.accept("./Patient.vue?vue&type=template&id=034054da&", function () {
      api.rerender('034054da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboards/columns/Patient.vue"
export default component.exports